<template>
  <div class="printed">
    <v-card outlined style="overflow-y: auto;">
      <v-card-text>
        <v-row>
          <v-col cols="8" sm="4" md="8">
            <v-row class="ml-1">
              <v-col cols="4" sm="2" md="4" class="pa-0" style="align-self: center" v-if="urlLogo!=null">
                <v-img
                  style="-webkit-print-color-adjust: exact"
                  :src="urlLogo"
                  max-height="150"
                  max-width="150"
                  lazy-src="https://via.placeholder.com/150"
                >
                </v-img>
                <!-- <v-avatar v-if="urlLogo!=null" left size="120">
                  <img
                    :src="urlLogo"
                    alt="Logo"
                  >
                </v-avatar> -->
              </v-col>
              <v-col cols="8" sm="4" md="8" class="pa-0" style="align-self: center">
                <h3 class="font-weight-bold mt-1 mb-1">{{dataUser.company == undefined ? 'Tidak ada nama' : dataUser.company.name}}</h3>
                <p class="mb-0">Telepon: {{dataUser.company == undefined ? 'Tidak ada telepon' : dataUser.company.telp}}</p>
                <p class="mb-0">Email: {{dataUser.company == undefined ? 'Tidak ada email' : dataUser.company.email}}</p>
                <p class="mb-0">Alamat: {{dataUser.company == undefined ? 'Tidak ada alamat' : dataUser.company.address}}</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="4" sm="2" md="4" style="align-self: center; text-align: -webkit-right;-webkit-print-color-adjust: exact">
            <!-- <h3 class="font-weight-bold text-right ma-0">{{dataDetails.type == 'PEMASUKAN' ? 'Invoice' : 'Purchase Order'}}</h3> -->
            <!-- <h3 v-if="dataDetails.type == 'PEMASUKAN'" class="font-weight-bold text-right ma-0 green--text">Invoice</h3>
            <h3 v-else class="font-weight-bold text-right ma-0 red--text">Purchase Order</h3> -->
            <v-card
              v-if="submissionType == 'PEMASUKAN'"
              elevation="0"
              height="40"
              width="150"
              class="green"
            >
              <v-row
                class="fill-height white--text h4 ma-0"
                align="center"
                justify="center"
                v-text="'Pemasukan'"
              ></v-row>
            </v-card>
            <v-card
              v-else
              elevation="0"
              height="40"
              width="150"
              class="red"
            >
              <v-row
                class="fill-height white--text h4 ma-0"
                align="center"
                justify="center"
                v-text="'Pengeluaran'"
              ></v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="2" md="12" style="border-top: 1px solid;-webkit-print-color-adjust: exact">
            <p class="font-weight-bold ma-0">Laporan {{  submissionType == 'PEMASUKAN' ? 'Pemasukan' : 'Pengeluaran'  }} Dari Tanggal {{ formatdate(this.$route.params.tanggalFrom) }} Sampai Tanggal {{ formatdate(this.$route.params.tanggalTo) }}</p>
            <!-- <p class="font-weight-bold ma-0">Nama {{dataDetails.type == 'PEMASUKAN' ? 'Pemasukan' : 'Pengeluaran'}}:</p><p class="text-left ma-0">{{dataDetails.name == null ? 'Tidak ada nama' : dataDetails.name}}</p>
            <p class="font-weight-bold ma-0">Catatan:</p><p class="text-left ma-0">{{dataDetails.note == null ? 'Tidak ada catatan' : dataDetails.note}}</p> -->
          </v-col>
          <!-- <v-col cols="4" sm="2" md="4" class="text-center" style="border-top: 1px solid;-webkit-print-color-adjust: exact"> -->
            <!-- <p class="font-weight-bold ma-0">STATUS </p>
            <template v-if="dataDetails.status == 'COMPLETED'">
              <v-chip
                class="mb-2"
                color="green"
                label
                outlined
              >
                <v-icon left>check_box</v-icon>
                {{dataDetails.status}}
              </v-chip>
            </template> -->
          <!-- </v-col> -->
          <!-- <v-col cols="4" sm="2" md="4" style="border-top: 1px solid;-webkit-print-color-adjust: exact"> -->
            <!-- <p class="font-weight-bold text-right ma-0">Nama Petugas</p><p class="text-right ma-0">{{dataUser.name}}</p>
            <p class="font-weight-bold text-right ma-0">{{dataDetails.type == 'PEMASUKAN' ? 'Invoice Number:' : 'Purchase Number:'}}</p><p class="text-right ma-0">{{dataDetails.id}}</p>
            <p class="font-weight-bold text-right ma-0">Jumlah Pesanan:</p><p class="text-right ma-0">{{dataDetails.items.length}}</p> -->
          <!-- </v-col> -->
        </v-row>
        <v-simple-table fixed-header max-height="300px" class="mb-4 mt-4">
          <template>
            <thead>
              <tr>
                <td style="background-color: lightgray!important;-webkit-print-color-adjust: exact" v-for="header in computedHeaders" :key="header.text" :class="header.align">{{ header.text }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(subItem, index) in listItems" :key="subItem.id">
                  <td>{{ index+1 }}</td>
                  <td>{{ subItem.item_name }}</td>
                  <td>{{ Number(subItem.jumlah) }}</td>
                  <td>{{ convertCurrency(subItem.harga) }}</td>
                  <td>{{ convertCurrency(subItem.totals) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider></v-divider>
        <div style="padding:0 5em;">
          <div :class="`d-flex justify-end`">
            <h5>Sub Total {{  submissionType == 'PEMASUKAN' ? 'Pemasukan' : 'Pengeluaran'  }} : <b v-if="submissionType == 'PEMASUKAN'" style="color: #43A047;">{{convertCurrency(sub_total)}}</b><b v-else style="color: red">{{convertCurrency(sub_total)}}</b></h5>
          </div>
          <div :class="`d-flex justify-end`">
            <h5> {{  submissionType == 'PEMASUKAN' ? 'Pemasukan Cancel' : 'Pengeluaran Cancel'  }} : <b v-if="submissionType == 'PEMASUKAN'" style="color: #43A047;">{{convertCurrency(total_canceled)}}</b><b v-else style="color: red;">{{convertCurrency(total_canceled)}}</b></h5>
          </div>
        </div>
        <hr />
        <div style="padding:0 5em;">
          <div :class="`d-flex justify-end`">
            <h5>Total {{  submissionType == 'PEMASUKAN' ? 'Pemasukan' : 'Pengeluaran'  }} : <b v-if="submissionType == 'PEMASUKAN'" style="color: #43A047;">{{convertCurrency(total)}}</b><b v-else style="color: red;">{{convertCurrency(total)}}</b></h5>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import isEmpty from "lodash/isEmpty";
import { formatCurrency } from "@/libs/number";
import moment from "moment";
export default {
  data: () => ({
    dialog2: false,
    dialog3: false,
    dialog: false,
    dialogNote: false,
    dialogApproval: false,
    dialogDetail: false,
    expand: false,
    note: '',
    approval: '',
    role: '',
    showError: false,
    dataUser: {},
    produk: [],
    listItems: [],
    
    // headers: [
    //   {
    //     text: "Nama",
    //     align: "left",
    //     value: "name"
    //   },
    //   { text: "Harga", value: "price" },
    //   { text: "Jumlah", value: "qty" },
    //   { text: "Total Harga", value: "total" },
    //   { text: "Total Harga", value: "total" },
    //   { text: "Total Harga", value: "total" },
    //   { text: "Tanggal", value: "date" },
    //   { text: "Status", value: "status" },
    //   { text: "Actions", value: "action", sortable: false }
    // ],
    item_pemasukan: [],
    dataDetails: { 
      "items": []
    },
    editedIndex: -1,
    editedItem: {
      // price: "",
      // qty: "",
      total: "",
      // date: "",
    },
    defaultItem: {
      // price: "",
      // qty: "",
      total: "",
      // date: "",
    },
    items: [{
      product_id: 0,
      item_name: "",
      harga_jual: "",
      harga_beli: "",
      qty: ""
    }],
    paymentItems: null,
    headerSubItem: [
      {
        text: "No.",
        align: "left",
        value: "no"
      },
      { text: "Nama Item", value: "item_name" },
      { text: "Jumlah", value: "jumlah" },
      { text: "Harga", value: "harga" },
      { text: "Total", value: "total" },
    ],
    headerPaymentHistory: [
      { text: "Tanggal"},
      { text: "Jumlah"},
      { text: "Wallet",  align: 'text-right'},
    ],
    paymentMethod: ["Bank Transfer", "Cash"],
    paid: 0,
    jumlahPayment: 0,
    paymentMethodSelected: "",
    paymentDate: "",
    urlLogo: null,
    total_canceled: 0,
    sub_total: 0,
    total: 0,
    submissionType: "",
  }),

  computed: {
    computedHeaders () {
      let editedHeaders = this.headerSubItem
      if(this.dataDetails.company_id == 18) {
        editedHeaders = this.headerSubItem.filter(header => header.text !== "Diskon" && header.text !== "PPN");  
      }
      return editedHeaders;
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    formatdate(value){
      return moment(value).format("DD-MM-YYYY HH:mm:ss")
    },
    ...mapActions({
      getPemasukanByIdPOS: "pemasukan/getPemasukanByIdPOS",
      getTransaction: "transaction/getTransactionBySubmissionId",
      getUserById: "user/getUserById",
      getCompany: "company/getCompany",
      printLaporan: "laporan/printLaporan",
    }),
    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },
    
    async initialize() {
      this.submissionType = this.$route.params.type
      const payload = {
        date_from : this.$route.params.tanggalFrom,
        date_to : this.$route.params.tanggalTo,
        type : this.$route.params.type,
      }
      const response = await this.printLaporan(payload)
      if(isEmpty(response.data)){
        // console.log('error')
        this.$router.push('/error')
      }else{
        const responseUser = await this.getUserById(response.data.attributes.items[0].user_id)
        const responseCompany = await this.getCompany();
        forEach(responseCompany.data.attributes.company_attachment, attachment => {
          if(attachment.attachment_type == 'LOGO'){
            this.urlLogo = process.env.VUE_APP_ENDPOINT_ATTACHMENT_URL + '/' + attachment.location + '/' + attachment.name
          }
        })
        this.dataUser = Object.assign({}, responseUser.data.attributes)
        this.total_canceled = response.data.attributes.total_canceled
        this.total = response.data.attributes.total
        this.sub_total = response.data.attributes.sub_total
        await forEach(response.data.attributes.items, data => {
            data.harga = data.type == 'PEMASUKAN' ? data.harga_jual : data.harga_beli
            this.listItems.push(data)
        })
      }

      setTimeout(function () {
        var content = window.document.querySelector('body').innerHTML

        if (content.length) {
          window.print()
          window.close()
        } else {
          initialize()
        }
      }, 200)
    }, 
  }
};
</script>
<style>
@media print {
  img{
    display: inline;
    visibility: visible;
  }
}
</style>